import { Link, Text, View } from '@react-pdf/renderer';

import { IBatch } from '@/features/single-measurement/types';

import { formatBatch } from '../format-batch';

export const getDataTable = (batch: IBatch) => {
  const rows = Object.entries(formatBatch(batch));

  return (
    <View style={{ marginBottom: 30 }}>
      {rows.map((row) => (
        <View
          key={row[0]}
          style={{
            padding: 5,
            display: 'flex',
            marginVertical: 1,
            flexDirection: 'row',
            backgroundColor: '#e2e8f0',
          }}
        >
          <View style={{ width: 150 }}>
            <Text>{row[0]}</Text>
          </View>
          <View>
            {row[0] === 'Analysis Link' ? (
              <Link style={{ fontWeight: 200, color: '#1d4ed8' }} src={row[1]}>
                Open in your browser
              </Link>
            ) : (
              <Text style={{ fontWeight: 200 }}>{row[1]}</Text>
            )}
          </View>
        </View>
      ))}
    </View>
  );
};
